import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../service/authService.service';

@Injectable()
export class AutenticationInterceptor implements HttpInterceptor {
  private isRefreshing = false;

  constructor(private router: Router, private authService: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(this.addCredentials(req)).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          return this.handle401Error(error, req, next);
        }
        return throwError(() => error);
      })
    );
  }

  private addCredentials(request: HttpRequest<any>): HttpRequest<any> {
    // Pula a API externa do ViaCEP
    if (request.url.includes('viacep.com.br')) {
      return request;
    }
    
    // Clona a requisição e adiciona as credenciais para APIs internas
    return request.clone({
      setHeaders: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    });
  }

  private handle401Error(
    error: HttpErrorResponse,
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      return this.authService.refreshToken().pipe(
        switchMap(() => {
          this.isRefreshing = false;
          return next.handle(this.addCredentials(request)); // Reenvia a requisição original
        }),
        catchError(() => {
          this.isRefreshing = false;
          this.router.navigate(['/login']); // Redireciona para login se o refresh falhar
          return throwError(
            () => new HttpErrorResponse({ error: error, status: 401 })
          );
        })
      );
    }
    return throwError(
      () => new HttpErrorResponse({ error: error, status: 401 })
    );
  }
}
